/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsUserImage,
    SharedserviceMelcoModelsUserImageFromJSON,
    SharedserviceMelcoModelsUserImageFromJSONTyped,
    SharedserviceMelcoModelsUserImageToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoFusionModelsUpdateBlank
 */
export interface SharedserviceMelcoFusionModelsUpdateBlank {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoFusionModelsUpdateBlank
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoFusionModelsUpdateBlank
     */
    canvas_width?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoFusionModelsUpdateBlank
     */
    canvas_height?: number;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsUserImage>}
     * @memberof SharedserviceMelcoFusionModelsUpdateBlank
     */
    images?: Array<SharedserviceMelcoModelsUserImage> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SharedserviceMelcoFusionModelsUpdateBlank
     */
    colors?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SharedserviceMelcoFusionModelsUpdateBlank
     */
    views?: Array<string> | null;
}

export function SharedserviceMelcoFusionModelsUpdateBlankFromJSON(json: any): SharedserviceMelcoFusionModelsUpdateBlank {
    return SharedserviceMelcoFusionModelsUpdateBlankFromJSONTyped(json, false);
}

export function SharedserviceMelcoFusionModelsUpdateBlankFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoFusionModelsUpdateBlank {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'canvas_width': !exists(json, 'canvas_width') ? undefined : json['canvas_width'],
        'canvas_height': !exists(json, 'canvas_height') ? undefined : json['canvas_height'],
        'images': !exists(json, 'images') ? undefined : (json['images'] === null ? null : (json['images'] as Array<any>).map(SharedserviceMelcoModelsUserImageFromJSON)),
        'colors': !exists(json, 'colors') ? undefined : json['colors'],
        'views': !exists(json, 'views') ? undefined : json['views'],
    };
}

export function SharedserviceMelcoFusionModelsUpdateBlankToJSON(value?: SharedserviceMelcoFusionModelsUpdateBlank | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'canvas_width': value.canvas_width,
        'canvas_height': value.canvas_height,
        'images': value.images === undefined ? undefined : (value.images === null ? null : (value.images as Array<any>).map(SharedserviceMelcoModelsUserImageToJSON)),
        'colors': value.colors,
        'views': value.views,
    };
}


